import React, { useContext } from 'react';
import { Input, Form } from 'antd';
// import _ from 'lodash-es';
import { ThemeContext } from 'styled-components';
// 引入ButtonStyled 组件;

import { AddInputMLStyled } from './AddInputMLStyled';
import { BrandContext } from '@/contexts/ContextProviders';

/**
 * 头部OK按钮
 * @param {*} param
 */
const InputML = ({
  placeVal,
  defaultValue,
  headerHeight = '47px',
  labelWidth = '169px',
  inputMinWidth = '190px',
  disabled,
  name,
  labelVal,
  required = [],
  className,
  type = 'string',
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  return (
    <AddInputMLStyled
      theme={themeContext}
      brand={brandContext}
      headerHeight={headerHeight}
      labelWidth={labelWidth}
      inputMinWidth={inputMinWidth}
    >
      <Form.Item
        colon={false}
        name={name}
        label={labelVal}
        rules={required}
        className={className}
      >
        <Input
          placeholder={placeVal}
          defaultValue={defaultValue}
          disabled={disabled}
          type={type}
        />
      </Form.Item>
    </AddInputMLStyled>
  );
};

export default InputML;
